<template>
  <div class="footer">
    <div class="footer-center">
      <div class="footer-cont" style="position:relative">
        <div class="set">
          <ul>
            <li @click="shadowShow">关于我们</li>
            <li @click="telShow">联系我们</li>
            <li @click="joinUs">加入我们</li>
            <li @click="opinionTkShow">意见反馈</li>
          </ul>
		  <ul>
			<li>友情链接</li>
		    <li v-for="(item,index) in youqing" :key="index" @click="goUrl(item.configValue)">{{item.title}}</li>
			<li></li>
		  </ul>
			<p class="footer_show border1">违法和不良信息举报电话：010-80595412</p>
			<p class="footer_show">举报邮箱：gzkj001@126.com</p>
			<p class="footer_show">©2019~2020 建筑档案丨<a href="http://beian.miit.gov.cn/">京 ICP 备 17067369 号-2</a></p>
			<p class="footer_show ">京 ICP 证 B2-20200691 丨北京构筑空间文化传媒有限公司</p>
			<p class="footer_hide">违法和不良信息举报电话：010-80595412 丨 举报邮箱：gzkj001@126.com</p>
			<p class="footer_hide" style="margin-bottom:20px;">©2019~2020 建筑档案丨<a href="http://beian.miit.gov.cn/">京 ICP 备 17067369 号-2</a>   丨京 ICP 证 B2-20200691丨北京构筑空间文化传媒有限公司</p>
		</div>
        <ul class="third-share">
          <li @click="wbshow">
            <img src="../../assets/img/wb.png" />
          </li>
          <li @click="wxshow">
            <img src="../../assets/img/wx.png" />
          </li>
          <li @click="phoneshow">
            <img src="../../assets/img/other.png" />
          </li>
        </ul>

        <!-- 三个二维码-->
        <div class="code wb" v-if="wbCode">
          <img src="../../assets/img/wb.jpg" alt />
        </div>
        <div class="code wx" v-if="wxCode">
          <img src="../../assets/img/wx.jpg" alt />
        </div>
        <div class="code phone" v-if="phoneCode">
          <img src="../../assets/img/phone.jpg" alt />
        </div>
      </div>
    </div>

    <!-- 关于我们 -->
    <div v-if="aboutUsShow" class="aboutUs">
      <div class="mask"></div>
      <div class="tk-msg">
        <p style="text-align:center;text-indent:0px;font-size:17px;margin-bottom:10px;">关于我们</p>
        <p>建筑档案：建筑行业全产业链内容共建，新一代融媒体运营服务与产品创新型平台。以记录与传承建筑文化为己任，促进建筑行业社会影响力。</p>
        <p>每个人都是档案记录人，注册档案号，开启你的建筑之旅！上传图像、文字、视频同步更新到网站，APP，小程序，实现你和你身边建筑的全过程记录。</p>
        <div class="sure" @click="shadowHide">我知道了</div>
      </div>
    </div>
    <!-- 联系我们 -->
    <div v-if="callShow" class="aboutUs">
      <div class="mask"></div>
      <div class="tk-msg">
        <p style="text-align:center;text-indent:0px;font-size:17px;margin-bottom:10px;">联系我们</p>
        <p>何先生： 15210322418（微信同步）</p>
        <p>邮箱： jzda01@126.com</p>
        <div class="sure" @click="shadowHide">我知道了</div>
      </div>
    </div>
    <!-- 加入我们 -->
    <div v-if="joinShow" class="aboutUs">
      <div class="mask"></div>
      <div class="tk-msg">
        <p style="text-align:center;text-indent:0px;font-size:17px;margin-bottom:10px;">加入我们</p>
        <p>何先生： 15210322418（微信同步）</p>
        <p>邮箱： jzda01@126.com</p>
        <div class="sure" @click="shadowHide">我知道了</div>
      </div>
    </div>
    <!-- 意见反馈 -->
    <div v-if="opinionShow" class="opinion">
      <div class="mask"></div>
      <div class="tk-msg">
        <p style="text-indent:0px;">请留下您宝贵的意见</p>
        <textarea v-model="opinion"></textarea>
        <ul>
          <li class="opin-btn" @click="shadowHide">关闭</li>
          <li class="opin-btn" @click="submit">提交</li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { setTimeout } from "timers";
export default {
  //   name: "App",
  data() {
    return {
      aboutUs: "",
      aboutUsShow: false,
      callShow: false,
      joinShow: false,
      opinionShow: false,
      opinion: "",
      wbCode: false,
      wxCode: false,
      phoneCode: false,
	  youqing:[]
    };
  },
  computed: {
    token() {
      console.log(this.$store.state.userInfo.token);
      return this.$store.state.userInfo.token;
    }
  },
  mounted() {
    this.getAboutUs();
	this.getyouqing()
  },
  methods: {
    wbshow() {
      this.wbCode = !this.wbCode;
      this.wxCode = false;
      this.phoneCode = false;
    },
    wxshow() {
      this.wbCode = false;
      this.wxCode = !this.wxCode;
      this.phoneCode = false;
    },
    phoneshow() {
      this.wbCode = false;
      this.wxCode = false;
      this.phoneCode = !this.phoneCode;
    },
    shadowShow() {
      //关于我们
	  window.location.href = 'https://www.jzda001.com/index/index/aboutus.html';
      // this.aboutUsShow = true;
    },
    shadowHide() {
      //弹框隐藏
      this.aboutUsShow = false;
      this.opinionShow = false;
      this.callShow = false;
      this.joinShow = false;
    },
    telShow() {
      //电话显示隐藏
	  window.location.href = 'https://www.jzda001.com/index/index/contact.html';
      // this.callShow = true;
    },
    joinUs() {
	  window.location.href = 'https://www.jzda001.com/index/index/joinus.html';
      // this.joinShow = true;
    },
    opinionTkShow() {
      //意见弹框
      this.opinionShow = true;
    },
	goUrl(url){
		window.location.href = url
	},
	getyouqing() {
	  this.$http
	    .get("/api/011-configGroupList", {
	      params: {
	        configGroup: 'blogroll',
	      }
	    })
	    .then(res => {
	      // console.log(res, "提交建议");
	      if (res.data.code == 0) {
	        var self = this;
	        this.youqing = res.data.rows
	      }
	    })
	    .catch(err => {
	      console.log(err);
	    });
	},
    submit() {
      //提交建议
      this.$http
        .get("/api/004-userFeedBack", {
          params: {
            token: this.token,
            content: this.opinion
          }
        })
        .then(res => {
          // console.log(res, "提交建议");
          if (res.data.code == 0) {
            this.$message("提交成功");
            var self = this;
            setTimeout(function() {
              self.opinionShow = false;
            }, 500);
          } else {
            this.$message(res.data.message);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getAboutUs() {
      // 获取发文规范
      this.$http
        .get("/api/001-dicList", {
          params: {
            keyWrod: "aboutUs"
          }
        })
        .then(res => {
          // console.log(res, "关于我们");
          if (res.data.code == 0) {
            this.aboutUs = res.data.rows[0].content;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    open() {
      this.$alert(this.aboutUs, "关于我们", {
        confirmButtonText: "确定",
        callback: action => {}
      });
    }
  }
};
</script>
<style scoped>
.code {
  width: 60px;
  height: 60px;
  overflow: hidden;
  position: absolute;
  /* top: -20px; */
}
.code img {
  width: 100%;
  height: 100%;
}
.code.wb {
  right: 130px;
}
.code.wx {
  right: 63px;
}
.code.phone {
  right: -5px;
}
.tk-msg {
  width: 500px;
  height: auto;
  background: #fff;
  z-index: 9999;
  position: fixed;
  bottom: 20%;
  left: 50%;
  margin-left: -200px;
  border-radius: 10px;
  padding: 30px 20px 20px;
}
.tk-msg p {
  text-align: left;
  font-size: 15px;
  text-indent: 30px;
  line-height: 28px;
}
.tk-msg .sure {
  width: 120px;
  height: 40px;
  line-height: 40px;
  margin: 30px auto 10px;
  background: #2e8043;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
}
.opinion .tk-msg {
  height: 550px;
}
.opinion .tk-msg textarea {
  width: 100%;
  height: 380px;
  margin-top: 20px;
  border-color: #ccc;
  border-radius: 4px;
  resize: none;
}
.opinion .tk-msg ul {
     width: 100%;
     margin: 30px auto 10px;
     overflow: hidden;
     display: flex;
     position: absolute;
     left: 0;
     justify-content: space-around;
}
.opinion .tk-msg ul .opin-btn {
  width: 120px;
  height: 40px;
  line-height: 40px;
  background: #2e8043;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
}
.opinion .tk-msg ul .opin-btn:first-child {
  background: #ccc;
  margin-right: 10px;
}

@media (min-width: 320px) and (max-width: 500px) {
  .footer {
    /* display: none;
    position: fixed;
    bottom: 0px; */
    width: 100%;
    /* height: 75px; */
	overflow: hidden;
    /* background: #fff; */
    /* border-top: 1px solid #bbb; */
  }
  .footer .footer-cont {
    width: 100%;
    margin-left: 0px;
  }
  .footer .third-share {
    display: none;
  }
  .footer .footer-center,
  .footer .footer-cont .set {
    width: 100%;
  }
  .footer .footer-cont .set ul {
    margin: 20px 0px;
    display: flex;
	height: 20px
  }
  .footer .footer-cont .set ul li {
    flex: 4;
    box-sizing: border-box;
    padding: 0px;
    border-right: 1px solid #0a8228;
	line-height: 20px;
  }
  .footer .footer-cont .set p {
    /* display: none; */
	padding: 0 20px;
	margin-top: 0px;
	color: #ccc;
	font-size: 12px;
  }
  .footer .footer-cont .set .border1{
	border-top: 1px solid #999;
	padding-top:10px;
	margin-top: 15px;
	/* padding-bottom: 5px; */
  }
  /* 弹框 */
  .tk-msg {
    width: calc(100% - 80px);
    left: 40px;
    margin-left: 0px;
  }
  .opinion .tk-msg {
    height: 400px;
    bottom: 20%;
  }
  .opinion .tk-msg textarea {
    height: 300px;
  }
}
</style>
